var map = {
	"./1B.svg": 152,
	"./1J.svg": 153,
	"./2B.svg": 154,
	"./2C.svg": 155,
	"./2D.svg": 156,
	"./2H.svg": 157,
	"./2J.svg": 158,
	"./2S.svg": 159,
	"./3C.svg": 160,
	"./3D.svg": 83,
	"./3H.svg": 161,
	"./3S.svg": 162,
	"./4C.svg": 163,
	"./4D.svg": 164,
	"./4H.svg": 165,
	"./4S.svg": 166,
	"./5C.svg": 167,
	"./5D.svg": 168,
	"./5H.svg": 169,
	"./5S.svg": 170,
	"./6C.svg": 171,
	"./6D.svg": 172,
	"./6H.svg": 173,
	"./6S.svg": 174,
	"./7C.svg": 175,
	"./7D.svg": 176,
	"./7H.svg": 177,
	"./7S.svg": 178,
	"./8C.svg": 179,
	"./8D.svg": 180,
	"./8H.svg": 181,
	"./8S.svg": 182,
	"./9C.svg": 183,
	"./9D.svg": 184,
	"./9H.svg": 185,
	"./9S.svg": 186,
	"./AC.svg": 187,
	"./AD.svg": 188,
	"./AH.svg": 189,
	"./AS.svg": 190,
	"./JC.svg": 191,
	"./JD.svg": 192,
	"./JH.svg": 193,
	"./JS.svg": 194,
	"./KC.svg": 195,
	"./KD.svg": 196,
	"./KH.svg": 197,
	"./KS.svg": 198,
	"./QC.svg": 199,
	"./QD.svg": 200,
	"./QH.svg": 201,
	"./QS.svg": 202,
	"./TC.svg": 203,
	"./TD.svg": 204,
	"./TH.svg": 205,
	"./TS.svg": 206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;